var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row justify-center items-center circle bg-grey-3 text-grey-7",
      style: { height: _vm.height, width: _vm.width }
    },
    [_vm._v("\n  " + _vm._s(_vm.initials) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }